import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1201Model } from '../kymw1201.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { FeatureCode } from '../vo/feature-code.model';

// レスポンス構造
export type GetFeatureCodeListResponse = {
  FeatureCodeList: {
    FeatureCode: string;
    FeatureName: string;
  }[];
};

/**
 * 特集コード一覧取得サービス
 * @export GetFeatureCodeList
 * @class GetFeatureCodeList
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureCodeList extends PlessJsonResponderSub<GetFeatureCodeListResponse> {
  private model: KYMW1201Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureCodeList
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        FeatureCode: {
          condition: {
            OrderCode: this.model.orderCode,
            MediumType: this.model.mediumType,
          }
        }
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureCodeList
   */
  execute(model: KYMW1201Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getFeatureCodeList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureCodeList
   */
  success(data: GetFeatureCodeListResponse) {
    this.model.featureCodeList = data.FeatureCodeList.map(_ => {
      const label = _.FeatureCode + ':' + _.FeatureName;
      return new FeatureCode(
        _.FeatureCode,
        _.FeatureName,
        label,
      );
    })
    if (this.calbak) this.calbak();
  }
}
